import React from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Elements/ScrolToTop';
import Loader from "./components/Elements/Loader";
import { DebugClerk } from './DebugClerk';

const App = () => {
  // Only render DebugClerk if Clerk is available
  const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
  const isClerkAvailable = clerkKey && 
    (clerkKey.startsWith('pk_test_') || clerkKey.startsWith('pk_live_')) &&
    clerkKey !== 'pk_test_your_key_here' &&
    clerkKey.length > 30;
  
  return (
    <div className="App">
      <Components />  
      <ScrolToTop/>
      <Loader/>
      {isClerkAvailable && <DebugClerk />}
    </div>
  );
};

export default App;